
export default [
    {
        path: 'basicResourcesKy',
        name: { list: ['产业大数据', '资源', '资源数据', '基础资源'] },
        component: () => import('@/views/bigDataSetupKy/basicResources.vue')
    },
    {
        path: 'breedInfo',
        name: { list: ['产业大数据', '资源', '资源数据', '养殖信息'] },
        component: () => import('@/views/bigDataSetupKy/breedInfo.vue')
    },
    {
        path: 'brandListKy',
        name: { list: ['产业大数据', '资源', '资源数据', '品牌信息'] },
        component: () => import('@/views/bigDataSetupKy/brandList.vue')
    },
    {
        path: 'industrialParkKy',
        name: { list: ['产业大数据', '资源', '资源数据', '产业园信息'] },
        component: () => import('@/views/bigDataSetupKy/industrialPark.vue')
    }
    
    
]